import React, { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LeaderboardIframeWidget from '../../widgets/LeaderboardIframeWidget';
import SeasonLeaderboardTable from '../../widgets/SeasonLeaderboardWidget/SeasonLeaderboardTable';
import { environmentVariables } from '../../utils/helpers/environmentVariables';
import { LoginContext } from '../../context/login.context';
import './SeasonLeaderboard.scss';

const SeasonLeaderboard: React.FC = () => {
    const { seasonId } = useParams<{ seasonId: string }>();
    const navigate = useNavigate();
    const { isInternalUser } = useContext(LoginContext);
    const baseUrl = environmentVariables.sailgpResultsUrl();
    const iframeUrl = baseUrl && seasonId ? `${baseUrl}?widget=true&contentonly=true&seasonId=${seasonId}` : '';

    if (!seasonId) {
        return (
            <div className="season-leaderboard-container">
                <div className="season-leaderboard-error">
                    <h2>Season not found</h2>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/schedule')}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back to Schedule
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className={`season-leaderboard-container ${!isInternalUser ? 'with-iframe' : ''}`}>
            <div className="season-leaderboard-header">
                <Button
                    className="season-leaderboard-back-button"
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    startIcon={<ArrowBackIcon />}
                >
                    Back
                </Button>
                <h1 className="season-leaderboard-title">
                    Season {seasonId} Championship Standings
                </h1>
            </div>

            <div className="season-leaderboard-content">
                {isInternalUser ? (
                    <SeasonLeaderboardTable seasonId={seasonId} />
                ) : iframeUrl ? (
                    <LeaderboardIframeWidget
                        src={iframeUrl}
                        title="Championship Standings"
                    />
                ) : (
                    <div style={{ color: '#999', padding: '20px' }}>
                        Results URL not configured
                    </div>
                )}
            </div>
        </div>
    );
};

export default SeasonLeaderboard;
